import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  List,
  ListItemText,
  Button,
  Tabs,
  Tab,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import {
  StyledContainer,
  StyledTypography,
  StyledTabs,
  StyledTab,
  StyledListItem,
  StyledButton,
  StyledBox,
  ModalTypography,
  ReopenButton,
  StyledDialogTitle,
  CloseButton,
} from "../../style/User/TicketHistoryStyles";
import { getAllSupportTickets, reopenSupportTicket } from "../../services/supportServices";
import { ToastContainer, toast } from "react-toastify";

function TicketHistory() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [resolvedTickets, setResolvedTickets] = useState([]);
  const [pendingTickets, setPendingTickets] = useState([]);

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const response = await getAllSupportTickets();
        console.log("Fetched tickets:", response);
        if (response?.success) {
          const resolved = response.tickets.filter((ticket) => ticket.status === "resolved");
          console.log("Resolved tickets:", resolved);
          const pending = response.tickets.filter((ticket) => ticket.status === "in-process");
          console.log("Pending tickets:", pending);
          setResolvedTickets(resolved);
          setPendingTickets(pending);
        } else {
          toast.error("Failed to fetch tickets.");
        }
      } catch (error) {
        console.error("Error fetching tickets:", error);
        toast.error("An error occurred while fetching tickets.");
      }
    };

    fetchTickets();
  }, []);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleOpenModal = (ticket) => {
    setSelectedTicket(ticket);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedTicket(null);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString();
  };

  const moveToPending = async (ticket) => {
    try {
      const payload = { ticketId: ticket.ticketId };
      const response = await reopenSupportTicket(payload);
      if (response?.success) {
        setResolvedTickets((prev) => prev.filter((t) => t.ticketId !== ticket.ticketId));
        setPendingTickets((prev) => [...prev, { ...ticket, status: "In-Process" }]);
        toast.success("Ticket successfully reopened.");
      } else {
        toast.error(response?.message || "Failed to reopen the ticket.");
      }
    } catch (error) {
      console.error("Error reopening ticket:", error);
      if (error.response) {
        console.error("Response data:", error.response.data);
        console.error("Response status:", error.response.status);
        console.error("Response headers:", error.response.headers);
      } else if (error.request) {
        console.error("Request made but no response received:", error.request);
      } else {
        console.error("Error setting up the request:", error.message);
      }
      toast.error("An error occurred while reopening the ticket.");
    } finally {
      handleCloseModal();
    }
  };

  return (
    <StyledContainer>
      <StyledTypography variant="h4" gutterBottom>
        Ticket History
      </StyledTypography>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        Below is the list of your past tickets:
      </Typography>

      <StyledTabs value={selectedTab} onChange={handleTabChange} aria-label="ticket status tabs">
        <StyledTab label="Pending Tickets" />
        <StyledTab label="Resolved Tickets" />
      </StyledTabs>

      <List>
        {(selectedTab === 0 ? pendingTickets : resolvedTickets).map((ticket) => (
          <StyledListItem key={ticket.ticketId}>
            <StyledBox>
              <ListItemText
                primary={`Ticket ID: ${ticket.ticketId}`}
                secondary={`Status: ${ticket.status}`}
              />
              <StyledButton variant="text" onClick={() => handleOpenModal(ticket)}>
                View Details
              </StyledButton>
            </StyledBox>
            <Box>
              <Typography variant="body2" color="textSecondary">
                { ticket.createdAt }
              </Typography>
            </Box>
          </StyledListItem>
        ))}
      </List>

      <Dialog   fullWidth
      maxWidth="sm"  open={modalOpen} onClose={handleCloseModal}>
        <StyledDialogTitle>Ticket Details</StyledDialogTitle>
        <DialogContent>
          {selectedTicket && (
            <Box>
              <ModalTypography variant="body1">
                <strong>Ticket ID:</strong> {selectedTicket.ticketId}
              </ModalTypography>
              <ModalTypography variant="body1">
                <strong>Status:</strong> {selectedTicket.status}
              </ModalTypography>
              <ModalTypography variant="body1">
                <strong>Date:</strong> { selectedTicket.createdAt }
              </ModalTypography>
              <ModalTypography variant="body1">
                <strong>Age:</strong> {selectedTicket.age} days
              </ModalTypography>
              <ModalTypography variant="body1">
                <strong>Subject:</strong> {selectedTicket.subjectType || "N/A"}
              </ModalTypography>
              <ModalTypography variant="body1">
                <strong>Message:</strong> {selectedTicket.message || "N/A"}
              </ModalTypography>
              <ModalTypography variant="body1">
                <strong>Remarks:</strong> {selectedTicket.remarks || "N/A"}
              </ModalTypography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          {selectedTicket?.status === "resolved" && (
            <ReopenButton onClick={() => moveToPending(selectedTicket)} variant="contained">
              Reopen Ticket
            </ReopenButton>
          )}
          <CloseButton onClick={handleCloseModal} variant="contained">
            Close
          </CloseButton>
        </DialogActions>
      </Dialog>
      <ToastContainer autoClose={3000} />
    </StyledContainer>
  );
}

export default TicketHistory;
